
function SendResentLinkTeamMember() {
  const resetPasswordButton = $('#resetPasswordTeamMember');
  resetPasswordButton.on('click', function(e) {
    e.preventDefault();
    $('#reset-password').submit();
  });
}

module.exports = {
  init: SendResentLinkTeamMember,
  url: /^\/settings\/membros-de-equipe/
};

